import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";

export const OtherProjects = () => {
  const { t } = useLanguage();
  const a = t.home.about;
  return (
    <section id="other-projects" className="relative bg-ink py-28 md:py-36 px-6 md:px-12 lg:px-20 border-t border-white/10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-mono text-brand-cyan text-xs tracking-[0.25em] mb-8" data-testid="other-projects-eyebrow">
          {a.otherLabel}
        </p>
        <Link
          to="/scuba"
          data-testid="other-projects-card"
          className="group relative grid grid-cols-1 md:grid-cols-2 overflow-hidden border border-white/10 hover:border-brand-cyan/50 transition-colors duration-500 max-w-4xl"
        >
          <div className="relative h-64 md:h-80">
            <img
              src={IMAGES.scuba.hero}
              alt="Polvo Scuba"
              className="h-full w-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent md:hidden" />
          </div>
          <div className="p-8 md:p-10 flex flex-col justify-center">
            <div className="flex items-center justify-between gap-4 mb-3">
              <h3 className="font-syne text-3xl text-white">{a.otherTitle}</h3>
              <ArrowUpRight className="w-6 h-6 text-white/50 group-hover:text-brand-cyan group-hover:rotate-45 transition-all duration-500" />
            </div>
            <p className="font-manrope text-sm text-white/55 leading-relaxed mb-4">{a.otherDesc}</p>
            <span className="font-manrope text-sm text-brand-cyan font-semibold" data-testid="other-projects-cta">
              {a.otherCta}
            </span>
          </div>
        </Link>
      </motion.div>
    </section>
  );
};
